import { connect } from 'react-redux'

import {
  getOnboardingNewProTrackLevels,
  getOnboardingCurrentProTrack,
  getOnboardingPreviousProTracks,
} from 'store/entities/identity/selectors'

import ProtracksLevels from './ProtracksLevels'

const mapStateToProps = state => ({
  newProTrackLevels: getOnboardingNewProTrackLevels(state),
  currentProTrack: getOnboardingCurrentProTrack(state),
  previousProTracks: getOnboardingPreviousProTracks(state),
})

export default connect(mapStateToProps)(ProtracksLevels)
